import { Grid, TextField } from '@mui/material';

interface VarderingInputProps {
  enabled: boolean;
  label: string;
  onChange: (val: string) => void;
  value?: number | string;
  required?: boolean;
  error?: string;
  type?: React.InputHTMLAttributes<unknown>['type'];
}

export const VarderingInput: React.FC<VarderingInputProps> = ({
  enabled,
  label,
  onChange,
  value,
  required,
  error,
  type = 'number',
}) => (
  <Grid item xs={1}>
    <TextField
      value={value || ''}
      label={label}
      onChange={(e) => onChange(e.currentTarget.value)}
      required={required}
      error={!!error}
      helperText={error}
      disabled={!enabled}
      size="small"
      type={type}
    />
  </Grid>
);
